/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleFromJSON, RoleToJSON, } from './Role.js';
/**
 * Check if a given object implements the GetRoleResult interface.
 */
export function instanceOfGetRoleResult(value) {
    if (!('role' in value) || value['role'] === undefined)
        return false;
    return true;
}
export function GetRoleResultFromJSON(json) {
    return GetRoleResultFromJSONTyped(json, false);
}
export function GetRoleResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'role': RoleFromJSON(json['role']),
    };
}
export function GetRoleResultToJSON(json) {
    return GetRoleResultToJSONTyped(json, false);
}
export function GetRoleResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'role': RoleToJSON(value['role']),
    };
}
